import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import {
  AuthLayoutComponent,
  MainLayoutComponent,
} from 'shared-angular-components-avla';
import { AuthService } from 'base-angular-avla';

const basePaths = [
  { apiSuffix: '/client360-api', systemName: 'Api Cliente360' },
  { apiSuffix: '/api-risk', systemName: 'Api Riesgos' },
];

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'viewClient360', redirectTo: 'viewClient', pathMatch: 'full' },
  { path: 'viewScoreCompany360', redirectTo: 'viewScoreCompany', pathMatch: 'full' },
  {
    path: 'errorsLogout',
    loadChildren: () =>
      import('shared-angular-components-avla').then(m => m.MiscellaneousModule),
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('shared-angular-components-avla').then(m => m.AuthModule),
    data: { mode: false },
  },
  {
    path: 'ejemploTablas',
    loadChildren: () =>
      import('app/ejemplo-tablas/ejemplo-tablas.module').then(
        m => m.EjemploTablasModule
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    data: { pageTitle: 'semilla avla', mode: false, onBoarding: true },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('app/vista-homepage/vista-homepage.module').then(
            m => m.VistaHomepageModule
          ),
        data: { pageTitle: 'Inicio' },
        canActivate: [AuthService],
      },
      {
        path: 'vistaMantenedores',
        loadChildren: () =>
          import('app/views/vista-mantenedores/vista-mantenedores.module').then(
            m => m.VistaMantenedoresModule
          ),
        data: { pageTitle: 'Vista Mantenedores', urlApiBasePaths: basePaths },
        canActivate: [AuthService],
      },
      {
        path: 'viewClient',
        loadChildren: () =>
          import('app/views/view-client-360/view-client-360.module').then(
            m => m.ViewClient360Module
          ),
        data: { pageTitle: 'Vista cliente 360' },
        canActivate: [AuthService],
      },
      {
		  path: 'viewScoreCompany',
		  loadChildren: () => import('app/views/view-score-prospect/view-score-prospect.module').then(
			  m => m.ViewScoreProspectModule),
		  data: {pageTitle: 'Vista Score Empresa'},
		  canActivate: [AuthService]},
      {
        path: 'viewScore',
        loadChildren: () =>
          import('app/views/view-score-massive/view-score-massive.module').then(
            m => m.ViewScoreMassiveModule
          ),
        data: { pageTitle: 'Vista Scores masivos' },
        canActivate: [AuthService],
      },
      {
        path: 'mantenedorParametros/parametros',
        loadChildren: () =>
          import(
            'parameters-front-components/views/createOrEditParameter/create-or-edit-parameter.module'
          ).then(m => m.CreateOrEditParameterModule),
        data: { urlApiBasePaths: basePaths },
        canActivate: [AuthService],
      },
      {
        path: 'external-documents/individual-consult',
        loadChildren: () =>
          import(
            'app/views/external-documents-individual/external-documents-individual.module'
          ).then(m => m.ExternalDocumentsIndividualModule),
        data: { pageTitle: 'Consulta Individual' },
        canActivate: [AuthService],
      },
      {
        path: 'risk',
        loadChildren: () =>
          import('risk-models-front-components').then(m => m.FlowModule),
        canActivate: [AuthService],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('docgenerator-front-components').then(
            m => m.DocGeneratorModule
          ),
        data: { urlApiBasePaths: basePaths },
        canActivate: [AuthService],
      },
      {
        path: 'actionLogs',
        loadChildren: () =>
          import('user_action_log_front_components').then(
            m => m.UserActionLogModule
          ),
        data: {
          pageTitle: 'Logs de acciones de usuarios',
          urlApiBasePaths: basePaths,
        },
        canActivate: [AuthService],
      },
      {
        path: 'errors',
        loadChildren: () =>
          import('shared-angular-components-avla').then(
            m => m.MiscellaneousModule
          ),
      },
    ],
    canActivate: [AuthService],
  },

  {
    /* ESTE SIEMPRE DEBE IR AL FINAL DEL LISTADO!!! */ path: '**',
    redirectTo: '/errorsLogout/error404',
  },
  //
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
  useHash: true,
  scrollPositionRestoration: 'enabled',
});
